/**
 * Radius System
 * Defines border radius values for components
 */

export enum RadiusSize {
  None = 'none',
  Small = 'small',
  Medium = 'medium',
  Large = 'large',
  Rounded = 'rounded',
}

export const RadiusValue: Record<RadiusSize, number> = {
  [RadiusSize.None]: 0,
  [RadiusSize.Small]: 8,
  [RadiusSize.Medium]: 24,
  [RadiusSize.Large]: 32,
  [RadiusSize.Rounded]: 40,
};

/**
 * Get radius value in pixels
 */
export function getRadiusValue(size: RadiusSize): number {
  return RadiusValue[size];
}

/**
 * Render a radius as its CSS length.
 *
 * A corner radius is absolute geometry, not typography: a surface that asks for
 * 12px must paint 12px, and concentric radius ladders only hold if every rung
 * lands on the value it names. Radii therefore stay in `px` and must NOT go
 * through `pxToRem` — that divides by `BASE_FONT_SIZE` (15) while the document
 * root font size is the browser default 16px, so every radius routed through it
 * paints 16/15 (~6.67%) larger than asked for (12 -> 12.8, 999 -> 1065.6).
 */
export function getRadiusCssValue(radiusPx: number): string {
  return `${radiusPx}px`;
}

